import { tripodActions } from "./reducer";
import _ from "lodash";
import tripodServices from "../../../../services/TripodService";

//tripod list thunk
const getTripodFilterDataThunk = () => async dispatch => {
  try {
    const response = await tripodServices.getTripodsFilterData();
    if (_.get(response, "data.success")) {
      const { stations, device_models, statuses } = _.get(
        response,
        "data.data",
        []
      );
      dispatch(
        tripodActions.getTripodFilterDataSucceed({
          stations,
          device_models,
          statuses
        })
      );
    } else {
      dispatch(tripodActions.getTripodFilterDataFailed());
    }
  } catch (e) {
    dispatch(tripodActions.getTripodFilterDataFailed());
  }
};
const getTripodList = param => async dispatch => {
  try {
    const response = await tripodServices.getListTripod(param);
    if (_.get(response, "data.success")) {
      const { data, total, online } = _.get(response, "data", {
        data: [],
        total: 0,
        online: 0
      });
      dispatch(tripodActions.getListTripodSucceed({ data, total, online }));
    } else {
      dispatch(tripodActions.getListTripodFailed());
    }
  } catch (e) {
    dispatch(tripodActions.getListTripodFailed());
  }
};

//tripod log thunk
const getLogFilterDataThunk = () => async dispatch => {
  try {
    const response = await tripodServices.getTripodLogFilterData();
    if (_.get(response, "data.success")) {
      const {
        device_ids,
        device_ips,
        verify_modes,
        checkin_types,
        sync_states,
        stations
      } = _.get(response, "data.data", {
        device_ids: [],
        device_ips: [],
        verify_modes: {},
        checkin_types: {},
        sync_states: {},
        stations: []
      });
      dispatch(
        tripodActions.getTripodLogFilterDataSucceed({
          device_ids,
          device_ips,
          verify_modes,
          checkin_types,
          sync_states,
          stations
        })
      );
    } else {
      dispatch(tripodActions.getTripodLogFilterDataFailed());
    }
  } catch (e) {
    dispatch(tripodActions.getTripodLogFilterDataFailed());
  }
};
const getTripodLogListThunk = param => async dispatch => {
  try {
    const response = await tripodServices.getTripodLogListData(param);
    if (_.get(response, "data.success")) {
      const { data, total } = _.get(response, "data.data", {
        data: [],
        total: 0
      });
      dispatch(tripodActions.getTripodLogListDataSucceed({ data, total }));
    } else {
      dispatch(tripodActions.getTripodLogListDataFailed());
    }
  } catch (e) {
    dispatch(tripodActions.getTripodLogListDataFailed());
  }
};

//tripod daily log thunk
const getDailyLogFilterDataThunk = () => async dispatch => {
  try {
    const response = await tripodServices.getTripodDailyLogFilterData();
    if (_.get(response, "data.success")) {
      const { departments, stations } = _.get(response, "data.data", {
        departments: [],
        stations: []
      });
      dispatch(
        tripodActions.getTripodDailyLogFilterDataSucceed({
          departments,
          stations
        })
      );
    } else {
      dispatch(tripodActions.getTripodDailyLogFilterDataFailed());
    }
  } catch (e) {
    dispatch(tripodActions.getTripodDailyLogFilterDataFailed());
  }
};
const getTripodDailyLogListThunk = param => async dispatch => {
  try {
    const response = await tripodServices.getTripodDailyLogListData(param);
    if (_.get(response, "data.success")) {
      const { data, total } = _.get(response, "data.data", {
        data: [],
        total: 0
      });
      dispatch(tripodActions.getTripodDailyLogListDataSucceed({ data, total }));
    } else {
      dispatch(tripodActions.getTripodDailyLogListDataFailed());
    }
  } catch (e) {
    dispatch(tripodActions.getTripodDailyLogListDataFailed());
  }
};

export const tripodThunks = {
  getTripodFilterDataThunk,
  getTripodList,
  getLogFilterDataThunk,
  getTripodLogListThunk,
  getDailyLogFilterDataThunk,
  getTripodDailyLogListThunk
};
